export type Constructable<T = object> = new (...args: any[]) => T;
